// TODO: refactor into smaller components

import styled, { css } from 'styled-components';

import { Image, inlineMediaQueryMixin, mediaBreakpointMixin, spaceMixin, token } from '@zillow/constellation';

import { HR } from '@zillow/zrs-comet';

/**
 * @param fontType - sets font size
 * @param fontFamily - sets font family
 */
export const StyledAsteriskAfter = styled.div<{ fontType?: string; fontFamily?: string }>`
  font-family: ${(props) => (props.fontFamily ? token(`fonts.${props.fontFamily}`) : token('fonts.sansSerif'))}px;

  &:after {
    content: '\u00a0*';
    color: #a3000b;
    font-size: ${(props) => (props.fontType ? token(`fontSizes.${props.fontType}`) : token('fontSizes.body'))}px;
    vertical-align: text-top;
  }
`;

export const StyledLineClamp = styled.div`
  display: -webkit-box;
  /* truncates at the second line */
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: 100%;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const StyledHR = styled(HR)`
  opacity: 0.4;
  margin: ${spaceMixin('lg')} 0;
`;

/** handle a smooth switch between a button and text button */
export const StyledSecondaryButtonHideShowContainer = styled.div`
  display: none;

  @media ${mediaBreakpointMixin('lg_gte')} {
    display: inline-block;
  }
`;

/** handle a smooth switch between a button and text button */
export const StyledSecondaryTextButtonHideShowContainer = styled.div`
  display: inline-block;

  @media ${mediaBreakpointMixin('lg_gte')} {
    display: none;
  }
`;

export const StyledHiddenAnchor = styled.div`
  display: block;
  position: relative;
  top: -55px;
  visibility: hidden;
`;

export const StyledImage = styled(Image)`
  ${inlineMediaQueryMixin(
    'size',
    (mediaProps: { size: string }) => css`
      width: ${spaceMixin(mediaProps.size)};
      height: ${spaceMixin(mediaProps.size)};
    `,
  )}
`;

/**
 * a utility element to help measure spacing
 * use dev tools to update values in order to position and measure
 */
export const StyledMeasureUtilBox = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  top: 0;
  left: 0;
  background: rgba(255, 0, 0, 0.5);
`;

export const StyledPlaceholderFormHelp = styled.div`
  min-height: ${spaceMixin('sm')};
`;

export const StyledRespondNowButtonContainer = styled.div`
  min-width: 94px;
`;
